import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import Swipr from 'react-swipr';

import QuestionnaireQuestion from './QuestionnaireQuestion';
import DetailLabel from 'components/DetailLabel';
import { QuestionnaireShape } from 'entities';
import './style.scss';

let lastId = 0;

class Questionnaire extends Component {

  constructor(...args) {
    super(...args);

    this.handleAnswer = this.handleAnswer.bind(this);
  }

  componentWillMount() {
    this.id = this.generateNewId();
  }

  // Swipr elementIds need to be unique
  generateNewId(prefix = 'id') {
    lastId += 1;
    return `${prefix}-${lastId}`;
  }

  handleAnswer(question, answerId, answerValue) {
    this.props.onQuestionAnswer(this.props.questionnaire, question, answerId, answerValue);
  }

  render() {
    return (
      <div className="Questionnaire">
        <div className="the-carousel">
          <Swipr elementId={`${this.props.questionnaire.id}-${this.id}`}>
            <QuestionnaireQuestion
              title={this.props.questionnaire.summary}
              description={this.props.questionnaire.description}
              tip={__('members.questionnaire.swipeStart')}
              />

            {this.props.questionnaire.questions.map(question => {
              return (<QuestionnaireQuestion
                key={question.id}
                question={question}
                onAnswer={this.handleAnswer}
              />);
            })}
          </Swipr>

          {!this.props.metaHidden &&
            <div className="meta">
              <DetailLabel>{moment(this.props.lastUpdated).fromNow()}</DetailLabel>
            </div>
          }
        </div>
      </div>
    );
  }
}

Questionnaire.propTypes = {
  questionnaire: QuestionnaireShape,
  onQuestionAnswer: PropTypes.func,
  lastRefresh: PropTypes.object,
  lastUpdated: PropTypes.object,
  metaHidden: PropTypes.bool
};

export default Questionnaire;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/Questionnaire/index.js
 **/